export default '/Volumes/Development_Lacie/Development/latest/jeep-sqlite/node_modules/sql.js/dist'